<input #fileInput class="filedrop__input" type="file" [attr.accept]="accept()" [multiple]="multiple()" [attr.aria-label]="buttonText()"
	(change)="onFileInputChange($event)" />

@if (variant() === 'inline') {
<section class="filedrop filedrop--inline" [class.filedrop--dragging]="isDragging()" [class.filedrop--disabled]="disabled()"
	(dragenter)="onDragEnter($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
	(drop)="onDrop($event)">
	<ng-container [ngTemplateOutlet]="dropzoneContent"></ng-container>
</section>
} @else if (variant() === 'modal') {
<button type="button" class="filedrop filedrop--modal-trigger" [class.filedrop--disabled]="disabled()" [disabled]="disabled()"
	(click)="openModal()">
	<ng-content></ng-content>
</button>

@if (isModalOpen()) {
<div class="filedrop-modal__backdrop" tabindex="-1" (click)="closeModal()" (keydown.escape)="closeModal()">
	<dialog class="filedrop-modal" open (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
		<button type="button" class="filedrop-modal__close" (click)="closeModal()" [attr.aria-label]="'common.actions.close' | translate">×</button>
		<section class="filedrop filedrop--inline" [class.filedrop--dragging]="isDragging()"
			[class.filedrop--disabled]="disabled()" (dragenter)="onDragEnter($event)" (dragover)="onDragOver($event)"
			(dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
			<ng-container [ngTemplateOutlet]="dropzoneContent"></ng-container>
		</section>
	</dialog>
</div>
}
} @else {
<div class="filedrop filedrop--content" [class.filedrop--dragging]="isDragging()" [class.filedrop--disabled]="disabled()"
	(dragenter)="onDragEnter($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
	(drop)="onDrop($event)">
	<ng-content></ng-content>

	@if (isDragging()) {
	<div class="filedrop__content-overlay" aria-live="polite">
		<div class="filedrop__content-message">
			<app-icon icon="icon-upload-regular.svg" color="var(--safegpt-primary)" [width]="42" [height]="42" />
			<strong>{{ overlayText() }}</strong>
		</div>
	</div>
	}
</div>
}

<ng-template #dropzoneContent>

	<div class="filedrop__zone">
		<span class="filedrop__icon">
			<app-icon icon="icon-upload-regular.svg" color="var(--safegpt-primary)" [width]="48" [height]="48" />
		</span>
		<strong>{{ title() }}</strong>
		<p>{{ subtitle() }}</p>
		<button type="button" class="filedrop__button" (click)="openFileDialog()" [disabled]="disabled() || isUploading()">
			<app-icon icon="icon-upload-regular.svg" color="currentColor" [width]="20" [height]="20" />
			{{ isUploading() ? ('shared.filedrop.uploading' | translate) : buttonText() }}
		</button>
	</div>

	<div class="filedrop__support">
		<div class="filedrop__support-title">
			<span aria-hidden="true">i</span>
			<strong>{{ supportedTypesTitle() }}</strong>
		</div>
		<div class="filedrop__extensions" [attr.aria-label]="'shared.filedrop.supportedTypesTitle' | translate">
			@for (extension of normalizedExtensions(); track extension) {
			<span>{{ extension }}</span>
			}
		</div>
		<p>{{ maxFileSizeLabel() }}</p>
	</div>

	@if (selectedFileNames().length) {
	<ul class="filedrop__messages" aria-live="polite">
		@for (fileName of selectedFileNames(); track fileName) {
		<li>{{ fileName }}</li>
		}
	</ul>
	}

	@if (rejectionMessages().length) {
	<ul class="filedrop__messages filedrop__messages--error" aria-live="assertive">
		@for (message of rejectionMessages(); track message) {
		<li>{{ message }}</li>
		}
	</ul>
	}
</ng-template>

